import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer' 
import Assestment1 from '../../assets/image/assesment1.png'
import psychologi_test_image from '../../assets/image/assestment/psychologi_test.jpg'
export default class psychologica_test extends Component {
    render() {
        const image=[
            {image:psychologi_test_image}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='consulting-section'>
                    <Banner bread_crum={['Assessment','Psychological Test']}  image={image} title="Psychological Test" subtitle=""/>
                    <br/><br/>
                    <div className='consulting-content'>
                        <h2>How we work</h2>
                        <br/><br/>
                        <div className='how'>
                            <p>
                                Psychological test is a set of items designed to measure characteristics of human beings that pertain behavior”.
                                <br/><br/>
                                Type of the test
                                Ability Test
                                1. Aptitude Test
                                2. Intelligence Test
                                <br/><br/>
                                Personality Test
                                1. Preference Test
                                2. Projective Test
                            </p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
